// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"Qj-z","trustedRetailerTooltipWrapper":"Rj-z"};